/** MagelUp owner password used to unlock password-protected PDF previews. */
export const MAGELUP_PDF_OWNER_PASSWORD = '2k1MjmVLpoHA';
